// @flow

import { type Amount } from '@tectonics/prs/money';
import { type CheckoutReceipts } from './types';

export function getAmountExt(receipts: CheckoutReceipts): Amount {
  return receipts.main.amount_ext;
}
